import axios from "axios";
import QS from "qs";
export default {
    SET_sendEmail: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api';
        let dataRequest = {
            action: 'sendEmail',
            fromAccount: context.getters.emailSettings.emailUserId,
            sendSubject: payload.sendSubject,
            sendDescription: payload.sendDescription,
            sendTo: payload.sendTo,
        }
        if (typeof payload.reCaptchaToken !== "undefined"){
            dataRequest.reCaptchaToken = payload.reCaptchaToken
        }
        try {
            const res_sendEmail = await axios.post(urlRequest, QS.stringify(dataRequest));
            return res_sendEmail
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    // eslint-disable-next-line no-unused-vars
    SET_sendSms: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api';

        const dataRequest = {
            action: 'sendSms',
            phoneNumber: payload.phoneNumber,
            message: payload.message,
        }
        try {
            return await axios.post(urlRequest, QS.stringify(dataRequest));
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
    SET_changeEmail: async (context, payload) => {
        const urlRequest = context.rootGetters["settingsAndCustomize/configurationSite"].urlSite + 'api';
        let dataRequest = {
            apiPointAction: 'SendChangeEmailLetter',
            action: 'apiPointPortal',
            emailAccount: context.getters.emailSettings.emailUserId,
            email: payload.email,
            idUser: payload.idUser,
            urlSite: context.rootGetters["settingsAndCustomize/configurationSite"].urlSite
        }
        try {
            const res_sendEmail = await axios.post(urlRequest, QS.stringify(dataRequest));
            return res_sendEmail
        } catch (e) {
            context.commit('setError', e, {root: true});
            throw e
        }
    },
}
